export const INACTIVE_DOCTOR_FETCH_INIT = "INACTIVE_DOCTOR_FETCH_INIT";
export const INACTIVE_DOCTOR_FETCH_SUCCESS = "INACTIVE_DOCTOR_FETCH_SUCCESS";
export const INACTIVE_DOCTOR_FETCH_FAIL = "INACTIVE_DOCTOR_FETCH_FAIL";
export const SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_INIT = "SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_INIT";
export const SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_SUCCESS = "SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_SUCCESS";
export const SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_ERROR = "SET_INACTIVE_DOCTOR_ACCOUNT_STATUS_ERROR";